import CommonButton from "@/components/utils/CommonButton";
import LazoTooltip from "@/components/utils/LazoTooltip";
import { Colors } from "@/enums/Colors";
import SaveIcon from "@mui/icons-material/Save";
import { Box, Chip, IconButton, Modal, styled, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Criteria } from "./PortalInboxStatistics";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: "16px",
  pt: 2,
  px: 4,
  pb: 3,
  display: "flex",
  flexDirection: "column",
  gap: 2,
};

const ITEM_NAME = "savedStatisticsFilters";

const PortalInboxSavedStatistics = ({ setCriteria, criteria }: { setCriteria: (c: Criteria) => void; criteria: Criteria }) => {
  const { t } = useTranslation("chat");
  const [savedCriterias, setSavedCriterias] = useState<{ name: string; criteria: Criteria }[]>([]);
  const [saveModal, setSaveModal] = useState<boolean>(false);
  const [name, setName] = useState<string>("");
  const [update, setUpdate] = useState<boolean>(false);

  const handleClose = () => setSaveModal(false);
  const handleOpen = () => setSaveModal(true);
  const updateData = () => setUpdate(!update);

  const save = () => {
    localStorage.setItem(ITEM_NAME, JSON.stringify([...savedCriterias, { name, criteria }]));
    setName("");
    updateData();
    handleClose();
  };

  useEffect(() => {
    const saved = localStorage.getItem(ITEM_NAME);
    if (saved) {
      setSavedCriterias(JSON.parse(saved));
    }
  }, [update]);

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          gap: 1,
          alignItems: "center",
        }}
      >
        <Typography>{t("savedFilters.title")}</Typography>
        {savedCriterias.map((sc) => (
          <LazoTooltip title={sc.name} key={sc.name}>
            <StyledChip
              label={sc.name}
              onClick={() => {
                setCriteria(sc.criteria);
              }}
            />
          </LazoTooltip>
        ))}
        <LazoTooltip title={t("savedFilters.saveTooltip")}>
          <IconButton onClick={handleOpen}>
            <SaveIcon sx={{ color: Colors.BUTTON_PURPLE }} />
          </IconButton>
        </LazoTooltip>
      </Box>
      <Modal open={saveModal} onClose={handleClose} aria-labelledby="parent-modal-title" aria-describedby="parent-modal-description">
        <Box sx={{ ...style, width: 200 }}>
          <TextField onChange={(e) => setName(e.target.value)} placeholder={t("savedFilters.nameInputPlaceholder")} />
          <CommonButton onClick={save} disabled={name.trim().length === 0}>
            {t("savedFilters.saveButton")}
          </CommonButton>
        </Box>
      </Modal>
    </>
  );
};

export default PortalInboxSavedStatistics;

const StyledChip = styled(Chip)(() => ({
  cursor: "pointer",
  backgroundColor: Colors.BUTTON_PURPLE,
  color: Colors.WHITE,
  boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.15)",
  ":hover": {
    backgroundColor: Colors.BUTTON_HOVER_PURPLE,
  },
}));
